import i18next from 'i18next';

import { canEditSupplierProducts } from '@selectors/actions/supplierProductActions';
import sortActionsList from '@commons/utils/sortActionsList';

export const getListActions = ({
  selectedItems,
  supplierProducts,
  authorizedActions,
  handleAvailabilitiesUpdate,
  handleDeactivation,
  handleExport,
}) => {
  const hasSelectedItems = !!selectedItems.length;
  const canEdit = canEditSupplierProducts(authorizedActions);

  return sortActionsList([
    {
      id: 'define-availabilities',
      actionLabel: i18next.t('ADMIN.SUPPLIER_PRODUCTS.ACTION_MANAGE_AVAILABILITY'),
      handleAction: () => handleAvailabilitiesUpdate(selectedItems),
      actionIcon: () => '/images/inpulse/pen-black-small.svg',
      isHidden: () => !canEdit || !hasSelectedItems,
    },
    {
      id: 'deactivate',
      actionLabel: i18next.t('ADMIN.STORES.CENTRAL_PRODUCTS_DEACTIVATE_ACTION', {
        count: selectedItems.length || 1,
      }),
      handleAction: () => handleDeactivation(selectedItems),
      actionIcon: () => '/images/inpulse/power-black-small.svg',
      isHidden: () => !canEdit || !hasSelectedItems,
    },
    {
      id: 'export',
      actionLabel: i18next.t('ADMIN.SUPPLIER_PRODUCTS.EXPORT_SELECTION', {
        count: selectedItems.length,
      }),
      handleAction: () => handleExport(hasSelectedItems ? selectedItems : null),
      actionIcon: () => '/images/inpulse/file-download-black-small.svg',
      isHidden: () => !supplierProducts.length,
    },
  ]);
};

export const getRowActions = ({
  authorizedActions,
  handleAvailabilitiesUpdate,
  handleDeactivation,
}) =>
  sortActionsList([
    {
      id: 'define-availabilities',
      actionLabel: () => i18next.t('ADMIN.SUPPLIER_PRODUCTS.ACTION_MANAGE_AVAILABILITY'),
      handleAction: (item) => handleAvailabilitiesUpdate([item]),
      actionIcon: () => '/images/inpulse/pen-black-small.svg',
      isHidden: () => !canEditSupplierProducts(authorizedActions),
    },
    {
      id: 'deactivate',
      actionLabel: () => i18next.t('ADMIN.STORES.CENTRAL_PRODUCTS_DEACTIVATE_ACTION', { count: 1 }),
      handleAction: (item) => handleDeactivation([item]),
      actionIcon: () => '/images/inpulse/power-black-small.svg',
      isHidden: () => !canEditSupplierProducts(authorizedActions),
    },
  ]);

export default { getListActions, getRowActions };
